export const oxxioExpandableTokens = {
  expandableIndicatorBackground: '{{ backgroundColors.backgroundTertiary }}',
  expandableDefaultIndicatorColor: '{{ iconColors.iconDarkBrand }}',
  expandableTransparentIndicatorColor: '{{ iconColors.iconBrand }}',
};
